export default theme => ({
    root: {
        marginTop: 10,
        display: 'flex',
        flexDirection: 'column',
    },
})